import React from 'react';
import { Link } from 'react-router-dom';
import Styles from './style.module.css';
import { Col, Container, Row } from 'react-bootstrap';

export default function ErrorPage() {
    return (
        <Col xl={12}>
            <Container>
                <Row>
                    <h1 className="text-center fw-bolder pt-5 text-danger">404</h1>
                    <article className={`${Styles.image}`} />
                </Row>
                <Row>
                    <article className='text-center p-3'>
                        <h3 className="h2">
                            Look like you're lost
                        </h3>
                        <p>the page you are looking for not avaible!</p>
                        <Link to="/" className="btn btn-outline-primary">Go to Home</Link>
                    </article>
                </Row>
            </Container>
        </Col>
    );
}